// extracted by mini-css-extract-plugin
export var contentWrapperStyle = "sr_quote_banner-module--contentWrapperStyle--iUn0v";
export var parallaxWrapperStyle = "sr_quote_banner-module--parallaxWrapperStyle--tjkTM";